<app-wig-summary (driverType)="setDriverType($event)" (fleet)="setFleet($event)"
(refreshStats)="refreshStatsCall()" ></app-wig-summary>
<div class="cre-layout-content">
  <app-wig-tabs
  #wigtabs [driverType]="driverType" [fleet]="fleet"></app-wig-tabs>
</div>
